'use client';
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
require('tailwind-merge');
require('@wishket/yogokit');
require('../../../_virtual/_tslib.js');
require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');
var Portal = require('../../Utils/Portal/Portal.js');
var LoadingIndicator = require('../LoadingIndicator/LoadingIndicator.js');

class LoadingManager {
    static getInstance() {
        if (!LoadingManager.instance) {
            LoadingManager.instance = new LoadingManager();
        }
        return LoadingManager.instance;
    }
    register(id) {
        if (!this.loaderIds.includes(id)) {
            this.loaderIds.push(id);
        }
    }
    unregister(id) {
        this.loaderIds = this.loaderIds.filter((loaderId)=>loaderId !== id);
    }
    getIsLastIndex(id) {
        return this.loaderIds[this.loaderIds.length - 1] === id;
    }
    constructor(){
        this.loaderIds = [];
    }
}
/**
 * 전역 로딩 인디케이터 컴포넌트입니다.
 * 화면 중앙에 로딩 스피너를 표시하며, 여러 개의 로딩 인디케이터가 동시에 존재할 경우
 * 가장 마지막에 생성된 인디케이터만 표시됩니다.
 *
 * @component
 * @param {GlobalLoadingIndicatorProps} props
 * @param {string} [props.size='md'] - 로딩 인디케이터의 크기. 'sm' | 'md' | 'lg' 중 선택
 * @param {string} [props.color='primary'] - 로딩 인디케이터의 색상. 'primary' | 'secondary' | 'white' 등 theme에 정의된 색상
 * @param {string} [props.className] - 추가적인 CSS 클래스명
 * @param {string} [props.testId] - 테스트를 위한 ID
 *
 * @example
 * // 기본 사용법
 * <GlobalLoadingIndicator />
 *
 * // 크기 지정
 * <GlobalLoadingIndicator size="lg" />
 *
 * // 색상 지정
 * <GlobalLoadingIndicator color="blue" />
 *
 * // 클래스명 추가
 * <GlobalLoadingIndicator className="custom-class" />
 */ const GlobalLoadingIndicator = (props)=>{
    const loadingManager = LoadingManager.getInstance();
    const id = react.useId();
    const [loaders, setLoaders] = react.useState([]);
    react.useEffect(()=>{
        loadingManager.register(id);
        setLoaders(loadingManager.loaderIds);
        return ()=>{
            loadingManager.unregister(id);
            setLoaders(loadingManager.loaderIds);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]);
    const isLastIndex = loaders.indexOf(id) === loaders.length - 1;
    if (!isLastIndex) return null;
    return jsxRuntime.jsx(Portal, {
        children: jsxRuntime.jsx("div", {
            "data-testid": "design-system-globalLoadingIndicator",
            className: "fixed left-1/2 top-1/2 z-30 aspect-square -translate-x-1/2 -translate-y-1/2",
            children: jsxRuntime.jsx(LoadingIndicator, Object.assign({}, props))
        })
    });
};

exports.LoadingManager = LoadingManager;
exports.default = GlobalLoadingIndicator;
